import styled from 'styled-components'

export const Container = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    .banner-home {
        margin: 55px 0px;
        width: 100%;
    }
    @media (max-width: 768px) {
    display: grid;
  }
`

export const UpperSection = styled.div`
    margin: 20px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
    h1 {
        color: #002666;
        font-size: 32px;
    }
    span {
        color: #a3a3a3;
    }
    a {
        color: #002666;
        text-decoration: underline;
    }
`

export const MiddleBanners = styled.div`
    margin-bottom: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    img {
        border-radius: 5px;
        width: 100%;
    }
`
